module.exports = "https://cdn.dove.it/_next/static/public/assets/services/promozione.0e056ebaa7fc0d20288a2cbabac82c1e.jpg";